import { alpha } from "@mui/material";

const styles = (theme) => ({
	paper: {
		display: "flex",
		flexDirection: "column",

		gap: 2,
		position: "relative",
	},
	linearProgress: {
		top: 1,
		left: 1,
		zIndex: 1,
		width: "99.9%",
		position: "absolute",
	},
	accordion: {
		transition: "all 0.2s ease", // suaviza animações
		"&:hover": {
			// efeito de elevação
			transform: "translateY(-2px)",
			boxShadow: `0px 4px 12px ${theme.palette.colors.black.darker}4D`,
		},
	},
	accordionTextStatus: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
	},
	summaryTextOverflow: {
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 2,
		overflow: "hidden",
		textOverflow: "ellipsis",
		// Fallback para navegadores que não suportam -webkit-line-clamp
		maxHeight: "3em", // Aproximadamente 2 linhas (1.5em por linha)
		lineHeight: 1.5,
	},
	accordionSummary: {
		"& .MuiAccordionSummary-content": {
			minWidth: 0, // Crucial para ellipsis
			overflow: "hidden",
		},
	},
	containerServiceItem: {
		display: "flex",
		flexDirection: "column",
		position: "relative",
	},
	containerTabsNActionButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		mt: 1,
	},
	tabs: {
		minHeight: 32,
		"& .MuiTabs-indicator": {
			display: "none", // remove a linha padrão
		},
	},
	tab: {
		minHeight: 32,
		paddingY: 0.5,
		px: 1,
		mx: 0.05,
		fontSize: "0.875rem",
		textTransform: "none",
		borderTopLeftRadius: "8px",
		borderTopRightRadius: "8px",
		border: "1px solid transparent",
		borderBottom: "none",
		transition: "all 0.2s ease",
	},

	tabLabel: {
		display: "flex",
		alignItems: "center",
		gap: 0.25,
	},
	tabCloseButton: {
		ml: 0.5,
		p: 0.1,
	},
	tabCloseIcon: {
		height: 16,
	},
	addTabDivider: {
		alignSelf: "center",
		height: "24px",
		borderRightWidth: 2,
		ml: 0.2,
	},
	addTabButton: {
		p: 0.5,
	},
	boxButtons: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
	},
	//cards do circuito
	paperFluxo: {
		borderRadius: "16px",
		flex: 1,
		height: "100%",
		overflowY: "auto",
		position: "relative",
		p: 1,
	},
	boxBlur: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "91px",
		zIndex: 2,
		backgroundColor: alpha(theme.palette.background.paper, 0.8),
		backdropFilter: "blur(6px)",
		transform: "translateY(7px)",
		borderTopLeftRadius: "30px",
		clipPath: "inset(0px 16px 0 10px)",
	},
	boxBody: {
		width: "100%",
		display: "flex",
		gap: 1,
		height: "700px",
		p: 1,
	},
	boxCampos: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		p: 0.5,
	},
	icons: {
		fontSize: 18,
		color: theme.palette.primary.main,
	},
	typhographyTitle: {
		fontWeight: "bold",
		fontSize: 14,
		color: theme.palette.text.secondary,
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	typographyLabel: {
		fontSize: 14,
		color: theme.palette.text.primary,
		overflow: "hidden",
		textOverflow: "ellipsis",
		cursor: "pointer",
		maxWidth: "150px",
	},
	headStcker: {
		display: "flex",
		flexDirection: "column",
		position: "sticky",
		backgroundColor: "transparent",
		top: 0,
		zIndex: 99,
		pt: 1,
		mb: -2,
	},
	divider: {
		mt: 2,
		mb: 1,
	},
	boxContent: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		mb: 1,
		mt: 2,
	},
	observationsTypography: {
		fontSize: 14,
		color: theme.palette.text.primary,
		overflow: "hidden",
		display: "-webkit-box",
		WebkitLineClamp: 10,
		WebkitBoxOrient: "vertical",
		textOverflow: "ellipsis",
		cursor: "pointer",
		whiteSpace: "pre-wrap",
		wordBreak: "break-word",
	},
	boxChip: {
		display: "flex",
		flexWrap: "wrap",
		gap: 1,
	},
});

export default styles;
